import React, { useState, useEffect } from "react";

import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
} from "../../models/Enums";
import AdductionAbduction from "../../assets/images/AdductionAbduction.png";
import LeftShoulderFAE from "../../assets/images/LeftShoulderFAE.png";
import RightShoulderFAE from "../../assets/images/RightShoulderFAE.png";
import LeftElbow from "../../assets/images/LeftElbow.png";
import RightElbow from "../../assets/images/RightElbow.png";
import LeftShoulderRotation from "../../assets/images/LeftShoulderRotation.png";
import RightShoulderRotation from "../../assets/images/RightShoulderRotation.png";
import LeftReach from "../../assets/images/leftReach.png";
import RightReach from "../../assets/images/rightReach.png";
import ForwardReach from "../../assets/images/forwardReach.png";

interface Props {
  assessment: AssessmentKey | FRAssessmentKey;
}
export type AssessmentKey = keyof typeof assesmentData;
export type FRAssessmentKey = keyof typeof FRAssesmentData;

const topBarThree = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="655"
    height="49"
    viewBox="0 0 655 49"
    fill="none"
  >
    <rect x="0.945801" y="14.5" width="190" height="20" rx="8" fill="#802392" />
    <rect x="198.946" y="14.5" width="190" height="20" rx="8" fill="#802392" />
    <rect x="396.946" y="14.5" width="190" height="20" rx="8" fill="#D9D9D9" />
    <path
      d="M597.179 37.964V33.716L608.051 24.068C608.867 23.348 609.443 22.67 609.779 22.034C610.115 21.398 610.283 20.804 610.283 20.252C610.283 19.46 610.121 18.758 609.797 18.146C609.473 17.522 609.017 17.036 608.429 16.688C607.841 16.328 607.151 16.148 606.359 16.148C605.531 16.148 604.799 16.34 604.163 16.724C603.539 17.096 603.053 17.594 602.705 18.218C602.357 18.83 602.195 19.496 602.219 20.216H597.179C597.179 18.44 597.569 16.904 598.349 15.608C599.129 14.312 600.215 13.31 601.607 12.602C602.999 11.894 604.619 11.54 606.467 11.54C608.159 11.54 609.671 11.912 611.003 12.656C612.347 13.388 613.403 14.414 614.171 15.734C614.939 17.054 615.323 18.584 615.323 20.324C615.323 21.608 615.143 22.676 614.783 23.528C614.423 24.368 613.889 25.148 613.181 25.868C612.473 26.576 611.603 27.38 610.571 28.28L603.551 34.436L603.155 33.356H615.323V37.964H597.179ZM626.178 12.08H631.074L624.162 38H619.266L626.178 12.08ZM643.323 38.468C642.027 38.468 640.791 38.21 639.615 37.694C638.439 37.166 637.413 36.428 636.537 35.48C635.673 34.532 635.055 33.416 634.683 32.132L639.435 30.872C639.687 31.82 640.179 32.558 640.911 33.086C641.655 33.602 642.459 33.86 643.323 33.86C644.067 33.86 644.745 33.68 645.357 33.32C645.981 32.96 646.473 32.474 646.833 31.862C647.205 31.25 647.391 30.572 647.391 29.828C647.391 28.712 647.007 27.758 646.239 26.966C645.483 26.162 644.511 25.76 643.323 25.76C642.963 25.76 642.615 25.814 642.279 25.922C641.943 26.018 641.619 26.156 641.307 26.336L639.111 22.484L647.355 15.644L647.715 16.688H635.691V12.08H651.891V16.688L645.483 22.88L645.447 21.512C646.935 21.74 648.189 22.262 649.209 23.078C650.241 23.882 651.021 24.878 651.549 26.066C652.089 27.242 652.359 28.496 652.359 29.828C652.359 31.46 651.945 32.93 651.117 34.238C650.289 35.534 649.191 36.566 647.823 37.334C646.455 38.09 644.955 38.468 643.323 38.468Z"
      fill="#31344E"
    />
  </svg>
);
const topBarTwo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="655"
    height="49"
    viewBox="0 0 655 49"
    fill="none"
  >
    <rect
      x="0.921875"
      y="14.5"
      width="290.5"
      height="20"
      rx="8"
      fill="#802392"
    />
    <rect
      x="299.422"
      y="14.5"
      width="290.5"
      height="20"
      rx="8"
      fill="#D9D9D9"
    />
    <path
      d="M613.256 38H607.824V23.1289C607.824 22.7188 607.83 22.2148 607.842 21.6172C607.854 21.0078 607.871 20.3867 607.895 19.7539C607.918 19.1094 607.941 18.5293 607.965 18.0137C607.836 18.166 607.572 18.4297 607.174 18.8047C606.787 19.168 606.424 19.4961 606.084 19.7891L603.131 22.1621L600.512 18.8926L608.791 12.3008H613.256V38ZM633.682 12.3008L624.102 38H619.232L628.812 12.3008H633.682ZM653.264 38H635.299V34.2207L641.75 27.6992C643.051 26.3633 644.094 25.25 644.879 24.3594C645.676 23.457 646.25 22.6367 646.602 21.8984C646.965 21.1602 647.146 20.3691 647.146 19.5254C647.146 18.5059 646.859 17.7441 646.285 17.2402C645.723 16.7246 644.967 16.4668 644.018 16.4668C643.021 16.4668 642.055 16.6953 641.117 17.1523C640.18 17.6094 639.201 18.2598 638.182 19.1035L635.229 15.6055C635.967 14.9727 636.746 14.375 637.566 13.8125C638.398 13.25 639.359 12.7988 640.449 12.459C641.551 12.1074 642.869 11.9316 644.404 11.9316C646.092 11.9316 647.539 12.2363 648.746 12.8457C649.965 13.4551 650.902 14.2871 651.559 15.3418C652.215 16.3848 652.543 17.5684 652.543 18.8926C652.543 20.3105 652.262 21.6055 651.699 22.7773C651.137 23.9492 650.316 25.1094 649.238 26.2578C648.172 27.4062 646.883 28.6777 645.371 30.0723L642.066 33.1836V33.4297H653.264V38Z"
      fill="#31344E"
    />
  </svg>
);
const lowerArrowsBothColor = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="677"
    height="96"
    viewBox="0 0 677 96"
    fill="none"
  >
    <path
      d="M46.8462 75.4976C48.2712 76.6826 50.2662 76.9526 51.9612 76.1576C53.6562 75.3626 54.7212 73.6676 54.7212 71.8076V23.8076C54.7212 21.9476 53.6412 20.2526 51.9612 19.4576C50.2812 18.6626 48.2862 18.9176 46.8462 20.1176L18.0462 44.1176L16.3212 45.5576V23.8076C16.3212 21.1526 14.1762 19.0076 11.5212 19.0076C8.86619 19.0076 6.72119 21.1526 6.72119 23.8076V71.8076C6.72119 74.4626 8.86619 76.6076 11.5212 76.6076C14.1762 76.6076 16.3212 74.4626 16.3212 71.8076V50.0576L18.0462 51.4976L46.8462 75.4976Z"
      fill="#802392"
    />
    <path
      d="M630.596 75.4976C629.171 76.6826 627.176 76.9526 625.481 76.1576C623.786 75.3626 622.721 73.6676 622.721 71.8076V23.8076C622.721 21.9476 623.801 20.2526 625.481 19.4576C627.161 18.6626 629.156 18.9176 630.596 20.1176L659.396 44.1176L661.121 45.5576V23.8076C661.121 21.1526 663.266 19.0076 665.921 19.0076C668.576 19.0076 670.721 21.1526 670.721 23.8076V71.8076C670.721 74.4626 668.576 76.6076 665.921 76.6076C663.266 76.6076 661.121 74.4626 661.121 71.8076V50.0576L659.396 51.4976L630.596 75.4976Z"
      fill="#802392"
    />
  </svg>
);
const lowerArrowsOneColor = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="677"
    height="96"
    viewBox="0 0 677 96"
    fill="none"
  >
    <path
      d="M46.8223 75.4973C48.2473 76.6823 50.2423 76.9523 51.9373 76.1573C53.6323 75.3623 54.6973 73.6673 54.6973 71.8073V23.8073C54.6973 21.9473 53.6173 20.2523 51.9373 19.4573C50.2573 18.6623 48.2623 18.9173 46.8223 20.1173L18.0223 44.1173L16.2973 45.5573V23.8073C16.2973 21.1523 14.1523 19.0073 11.4973 19.0073C8.84226 19.0073 6.69727 21.1523 6.69727 23.8073V71.8073C6.69727 74.4623 8.84226 76.6073 11.4973 76.6073C14.1523 76.6073 16.2973 74.4623 16.2973 71.8073V50.0573L18.0223 51.4973L46.8223 75.4973Z"
      fill="#D1D1D1"
    />
    <path
      d="M630.572 75.4973C629.147 76.6823 627.152 76.9523 625.457 76.1573C623.762 75.3623 622.697 73.6673 622.697 71.8073V23.8073C622.697 21.9473 623.777 20.2523 625.457 19.4573C627.137 18.6623 629.132 18.9173 630.572 20.1173L659.372 44.1173L661.097 45.5573V23.8073C661.097 21.1523 663.242 19.0073 665.897 19.0073C668.552 19.0073 670.697 21.1523 670.697 23.8073V71.8073C670.697 74.4623 668.552 76.6073 665.897 76.6073C663.242 76.6073 661.097 74.4623 661.097 71.8073V50.0573L659.372 51.4973L630.572 75.4973Z"
      fill="#802392"
    />
  </svg>
);

const assesmentData = {
  [AROM_ASSESSMENT.Shoulder_AAA]: {
    img: AdductionAbduction,
    main_heading: "Phase 1",
    text1: "Arms at side, palm",
    text2: "facing forward.",
    topBar: topBarThree,
    lowerArrows: lowerArrowsBothColor,
  },
  [AROM_ASSESSMENT.Left_Shoulder_FAE]: {
    img: LeftShoulderFAE,
    main_heading: "Phase 3: Right Arm",
    text1: "Right arm at side, palm",
    text2: "facing body",
    topBar: topBarThree,
    lowerArrows: lowerArrowsBothColor,
  },
  [AROM_ASSESSMENT.Right_Shoulder_FAE]: {
    img: RightShoulderFAE,
    main_heading: "Phase 2: Left Arm",
    text1: "Left arm at side, palm",
    text2: "facing body",
    topBar: topBarThree,
    lowerArrows: lowerArrowsBothColor,
  },
  [AROM_ASSESSMENT.Left_Elbow_FAE]: {
    img: LeftElbow,
    main_heading: "Phase 3: Right Arm",
    text1: "Right arm at side, palm",
    text2: "facing forward",
    topBar: topBarTwo,
    lowerArrows: lowerArrowsOneColor,
  },
  [AROM_ASSESSMENT.Right_Elbow_FAE]: {
    img: RightElbow,
    main_heading: "Phase 2: Left Arm",
    text1: "Left arm at side, palm",
    text2: "facing forward",
    topBar: topBarTwo,
    lowerArrows: lowerArrowsOneColor,
  },
  [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: {
    img: LeftShoulderRotation,
    main_heading: "Phase 3: Right Arm",
    text1: "Right Elbow at a 90",
    text2: "degree angle",
    topBar: topBarTwo,
    lowerArrows: lowerArrowsOneColor,
  },
  [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: {
    img: RightShoulderRotation,
    main_heading: "Phase 2: Left Arm",
    text1: "Left Elbow at a 90",
    text2: "degree angle",
    topBar: topBarTwo,
    lowerArrows: lowerArrowsOneColor,
  },
};

const FRAssesmentData = {
  [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: {
    img: LeftReach,
    main_heading: "Phase 1: Left Reach",
    text1: "Stand up straight and",
    text2: "extend your left arm.",
    topBar: topBarThree,
    lowerArrows: lowerArrowsBothColor,
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: {
    img: RightReach,
    main_heading: "Phase 2: Right Reach",
    text1: "Stand up straight and",
    text2: "extend your right arm.",
    topBar: topBarTwo,
    lowerArrows: lowerArrowsBothColor,
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: {
    img: ForwardReach,
    main_heading: "Phase 3: Forward Reach",
    text1: "Stand up straight and",
    text2: "extend your arms",
    topBar: topBarThree,
    lowerArrows: lowerArrowsBothColor,
  },
};

const AromAssessmentHandOrientationModal: React.FC<Props> = ({
  assessment,
}) => {
  return (
    <>
      <div
        className="generic-assesment-text-modal"
        style={{
          textAlign: "center",
        }}
      >
        <div className="align-center" style={{ height: "800px" }}>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            {sessionStorage.getItem("selectedAssesment") === "55"
              ? assesmentData[assessment as AssessmentKey].main_heading
              : FRAssesmentData[assessment as FRAssessmentKey].main_heading}
          </div>

          {sessionStorage.getItem("selectedAssesment") === "55"
            ? assesmentData[assessment as AssessmentKey].topBar
            : FRAssesmentData[assessment as FRAssessmentKey].topBar}

          <img
            style={{ width: 302, height: 387 }}
            src={
              sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].img
                : FRAssesmentData[assessment as FRAssessmentKey].img
            }
            alt="A description of hand orientation."
          />
          <div
            style={{
              fontSize: "55px",
              fontWeight: "550",
              lineHeight: "74.9px",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].text1
                : FRAssesmentData[assessment as FRAssessmentKey].text1}
            </div>
            <div>
              {sessionStorage.getItem("selectedAssesment") === "55"
                ? assesmentData[assessment as AssessmentKey].text2
                : FRAssesmentData[assessment as FRAssessmentKey].text2}
            </div>
          </div>
          {sessionStorage.getItem("selectedAssesment") === "55"
            ? assesmentData[assessment as AssessmentKey].lowerArrows
            : FRAssesmentData[assessment as FRAssessmentKey].lowerArrows}
        </div>
      </div>
    </>
  );
};
export default AromAssessmentHandOrientationModal;
